<template>
  <div class="container-fluid" v-if="!loading">
    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col ml-n2">
                <h4 class="mb-1">
                  <a
                    >{{ $t('saleReturns.form.invoice') }} <strong># {{ item.code }}</strong></a
                  >
                </h4>
              </div>
              <div class="col-auto">
                <router-link
                  :to="path + '/' + item.id + '/edit'"
                  class="btn btn-sm btn-primary"
                  :title="$t('saleReturns.show.Modification')"
                >
                  <i class="fas fa-edit"></i>
                </router-link>
                <a
                  :href="site + '/saleReturns/' + item.password + '/customer/show'"
                  class="btn btn-sm btn-primary"
                  target="_blank"
                  :title="$t('saleReturns.show.ExternalLink')"
                >
                  <i class="fas fa-link"></i>
                </a>
                <a
                  @click="print()"
                  class="btn btn-sm btn-primary"
                  :title="$t('saleReturns.show.Printing')"
                >
                  <i class="fas fa-print"></i>
                </a>
                <a
                  :href="$linkGnirator('/saleReturns/' + item.id + '/pdf')"
                  download
                  class="btn btn-sm btn-primary"
                  :title="$t('saleReturns.show.DownloadPDF')"
                >
                  <i class="fas fa-download"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="card card-body p-5 invoice-show">
          <div class="row">
            <div class="col">
              <div class="badge badge-dark" v-if="item.status == 0">
                {{ $t('saleReturns.draft') }}
              </div>
              <div class="badge badge-primary" v-if="item.status == 1">
                {{ $t('saleReturns.sent') }}
              </div>
              <div class="badge badge-primary" v-if="item.status == 2">
                {{ $t('saleReturns.seen') }}
              </div>
              <div class="badge badge-success" v-if="item.status == 3">
                {{ item.rest == 0 ? $t('saleReturns.driven') : $t('saleReturns.partiallyDriven') }}
              </div>
              <div class="badge badge-danger" v-if="item.status == 4">
                $t('saleReturns.canceled')
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <SalesReturnsComponent :item="item" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">{{ $t('saleReturns.invoice') }} : #{{ item.code }}</h4>
          </div>
          <div class="card-body">
            <ul class="list-unstyled">
              <li>
                <strong>{{ $t('invoices.show.createdIn') }}</strong> :
                {{ item.created }}
              </li>
              <li>
                <strong>{{ $t('invoices.show.LastUpdate') }}</strong> :
                {{ item.updated }}
              </li>
              <li v-if="item.client_type == 0">
                <strong>{{ $t('saleReturns.show.Client') }}</strong> :
                <router-link :to="'/customers/' + item.customer?.id">
                  {{ item.customer?.name }}</router-link
                >
              </li>
              <li v-if="item.client_type == 1">
                <strong>{{ $t('saleReturns.show.Client') }}</strong> :
                <router-link :to="'/suppliers/' + item.supplier?.id">
                  {{ item.supplier?.name }}</router-link
                >
              </li>
              <li>
                <strong>{{ $t('saleReturns.show.Administrator') }}</strong> :
                {{ item.user?.name }}
              </li>
            </ul>
          </div>
        </div>

        <div class="card" v-if="storesHistories.length != 0">
          <div class="card-header">
            <h4 class="card-header-title">
              <i class="far fa-store-alt"></i>
              {{ $t('saleReturns.show.WarehouseOperations') }}
            </h4>
          </div>
          <table class="table table-sm main-show">
            <thead>
              <tr>
                <th scope="col">{{ $t('saleReturns.show.Lots') }}</th>
                <th scope="col">{{ $t('saleReturns.show.theProduct') }}</th>
                <th scope="col">{{ $t('saleReturns.show.TheStore') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="storeHistory in storesHistories" :key="storeHistory.id">
                <td>
                  {{ storeHistory.type == 0 ? '+' : '-' }}
                  {{ storeHistory.quantity }}
                </td>
                <td>
                  <router-link :to="'/products/' + storeHistory.product.id" class="btn btn-light">
                    {{ storeHistory.product?.name }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="'/stores/' + storeHistory.store.id" class="btn btn-light">
                    {{ storeHistory.store?.name }}
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <showFile />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import showFile from '@/elements/show/showFile.vue'
import SalesReturnsComponent from '@/print/components/salereturns.vue'
export default {
  data() {
    return {
      path: '/saleReturns',
      logo: localStorage.getItem('logo'),
      item: {},
      salesPayments: {},
      storesHistories: {},
      amount: 0,
      type: 'show',
      loading: true,
      itemsCount: 0,

      printInvoice: false,
      site: localStorage.getItem('site')
    }
  },
  mounted() {
    this.getitem()
  },
  methods: {
    getitem() {
      axios.get(this.$linkGnirator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
        this.salesPayments = this.item.sales_payments
        this.storesHistories = this.item.stores_histories
        this.amount = this.item.rest
        this.item.quotationItems.forEach((item) => {
          this.itemsCount += item.quantity - 0
        })
        this.loading = false
      })
    },
    print(id) {
      this.$parent.printedSaleReturn = this.item
    }
  },
  components: {
    showFile,
    SalesReturnsComponent
  }
}
</script>
